import { Alert, Box, Grid } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { CraneSplitMessageUIStore } from '../stores/crane-split-message.ui-store'

interface Props {
  uiStore: CraneSplitMessageUIStore
}

export const CraneSplitErrorMessageContainer = observer(({ uiStore }: Props) => {
  return (
    <>
      {uiStore.message && (
        <Grid margin={'0.5rem'} size={12}>
          <Alert onClose={() => uiStore.setMessage()} severity={uiStore.severity}>
            <Box sx={{ whiteSpace: 'pre-wrap' }} data-cy='crane-split-warning-message'>
              {uiStore.message}
            </Box>
          </Alert>
        </Grid>
      )}
    </>
  )
})
